import { useEffect, useState } from 'react';

const MINUTE_MS = 60_000;

const untilNextMinute = (): number => MINUTE_MS - (Date.now() % MINUTE_MS);

// The current time, refreshed on every whole minute, and at once when the tab shows again after a sleep.
const useNow = (): Date => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      clearTimeout(timer);
      setNow(new Date());
      timer = setTimeout(refresh, untilNextMinute());
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        refresh();
      }
    };
    timer = setTimeout(refresh, untilNextMinute());
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
  return now;
};

export default useNow;
